// @flow
import type {SystemData} from '../../server/utils/systemData';

export type State = SystemData;

const initialState = {
    brand: 'homeaway_us',
    currency: 'USD',
    environment: 'development',
    fullLocale: '',
    isDesktop: false,
    isMetric: false,
    isMobile: false,
    isTablet: false,
    mockResponse: '',
    siteName: '',
    locale: 'en-US',
    hasSortLegalDisclaimer: false,
    facebook: {admins: '', appId: '', locale: 'en_US_HA'},
    domainName: '',
    hostname: '',
    directEntry: false,
    isInternalUser: false,
    consolidationBanner: '',
    referer: ''
};

const identity = (state: State = initialState) => state;

export default identity;
